'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CoreMapComponent = exports.defaultStyles = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  .leaflet-container {\n    width: 100%;\n    height: 100%;\n  }\n  .gm-style iframe {\n    width: 0px !important;\n    height: 0px !important;\n  }\n'], ['\n  .leaflet-container {\n    width: 100%;\n    height: 100%;\n  }\n  .gm-style iframe {\n    width: 0px !important;\n    height: 0px !important;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _leaflet = require('leaflet');

var _reactLeafletUniversal = require('react-leaflet-universal');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

require('react-leaflet-markercluster/dist/styles.min.css');

require('leaflet/dist/leaflet.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable global-require, react/no-multi-comp, react/jsx-no-bind */

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

var getMarkerBounds = function getMarkerBounds(markers) {
  var boundarySize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var boundaryPadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 15;

  var bounds = (markers || []).filter(function (marker) {
    return marker.geoIndexed;
  }).reduce(function (boundsResult, marker) {
    var coords = void 0;
    try {
      coords = new _leaflet.LatLng(marker.geoIndexed[1], marker.geoIndexed[0]);
    } catch (e) {
      return boundsResult;
    }

    if (!boundsResult) {
      // TODO : Check if coordinates are valid before adding to bounds
      return coords.toBounds(boundarySize);
    }
    if (boundsResult && marker.geoIndexed) {
      // TODO : Check if coordinates are valid before adding to bounds
      try {
        boundsResult.extend([parseFloat(marker.geoIndexed[1]), parseFloat(marker.geoIndexed[0])]);
      } catch (e) {
        console.error(e);
      }
    }
    return boundsResult;
  }, undefined);

  return {
    bounds: bounds && bounds.isValid() ? bounds.pad(boundaryPadding / 100) : undefined
  };
};

function withContext(WrappedComponent, context) {
  var ContextProvider = function (_React$Component) {
    _inherits(ContextProvider, _React$Component);

    function ContextProvider() {
      _classCallCheck(this, ContextProvider);

      return _possibleConstructorReturn(this, (ContextProvider.__proto__ || Object.getPrototypeOf(ContextProvider)).apply(this, arguments));
    }

    _createClass(ContextProvider, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return context;
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      }
    }]);

    return ContextProvider;
  }(_react2.default.Component);

  ContextProvider.childContextTypes = {};
  Object.keys(context).forEach(function (key) {
    ContextProvider.childContextTypes[key] = _propTypes2.default.any.isRequired;
  });

  return ContextProvider;
}

function validGeoIndex(index) {
  if (!index || !index[0] || !index[1] || index[0] > 180 || index[0] < -180 || index[1] > 90 || index[1] < -90) {
    return false;
  }

  return true;
}

var CoreMapComponent = exports.CoreMapComponent = function (_React$Component2) {
  _inherits(CoreMapComponent, _React$Component2);

  function CoreMapComponent(props) {
    _classCallCheck(this, CoreMapComponent);

    var _this2 = _possibleConstructorReturn(this, (CoreMapComponent.__proto__ || Object.getPrototypeOf(CoreMapComponent)).call(this, props));

    _this2.onPopupOpen = function () {
      _this2.setState({
        popupOpen: true
      });
    };

    _this2.onPopupClose = function () {
      _this2.setState({
        popupOpen: false
      });
    };

    _this2.state = {
      popupOpen: false
    };
    return _this2;
  }

  _createClass(CoreMapComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var polygons = _ref.polygons;

      if (polygons && polygons.length) {
        this.setBoundsFromPolygons();
      }
    }
  }, {
    key: 'setBoundsFromPolygons',
    value: function setBoundsFromPolygons() {
      var _this3 = this;

      setImmediate(function () {
        if (!_this3.polygonGroup || _this3.props.bounds) {
          return;
        }
        var bounds = _this3.polygonGroup.leafletElement.getBounds();
        if (bounds.isValid()) {
          _this3.setState({ bounds: bounds });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          activePin = _props.activePin,
          animate = _props.animate,
          boundaryPadding = _props.boundaryPadding,
          boundarySize = _props.boundarySize,
          bounds = _props.bounds,
          boundsOptions = _props.boundsOptions,
          center = _props.center,
          children = _props.children,
          className = _props.className,
          cluster = _props.cluster,
          hideTiles = _props.hideTiles,
          markers = _props.markers,
          pin = _props.pin,
          pins = _props.pins,
          polygons = _props.polygons,
          popup = _props.popup,
          useFlyTo = _props.useFlyTo,
          zoom = _props.zoom,
          zoomDisabled = _props.zoomDisabled;
      var popupOpen = this.state.popupOpen;


      var fallbackCoords = [{ geoIndexed: [-94.612146, 39.087320] }, // Kansas City
      { geoIndexed: [-94.820883, 38.881371] }];

      var key = this.props.key || _bdcoreUtilities.ConfigStore.getConfig('mapbox', {}).key;
      var tileUrl = this.props.tileUrl || _bdcoreUtilities.ConfigStore.getConfig('mapbox', {}).tileUrl || 'https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}';
      // const { key = '', tileUrl = 'https://api.mapbox.com/styles/v1/mapbox/streets-v9/tiles/256/{z}/{x}/{y}' } = ConfigStore.getConfig('mapbox', {});

      var _getMarkerBounds = getMarkerBounds(markers || fallbackCoords, boundarySize, boundaryPadding),
          markerBounds = _getMarkerBounds.bounds;

      var hasMarkers = markerBounds !== undefined && markers;
      var filteredMarkers = hasMarkers && markers.filter(function (marker) {
        return marker.geoIndexed && validGeoIndex(marker.geoIndexed);
      });

      var defaultIcon = new _leaflet.Icon(pin);

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          _reactLeafletUniversal.Map,
          {
            ref: function ref(map) {
              _this4.mapRef = map;
            },
            bounds: this.state.bounds || bounds || markerBounds,
            boundsOptions: boundsOptions,
            center: center,
            zoom: zoom || 8,
            maxZoom: 20,
            animate: animate,
            useFlyTo: useFlyTo,
            boxZoom: !zoomDisabled,
            doubleClickZoom: !zoomDisabled,
            dragging: !zoomDisabled,
            touchZoom: !zoomDisabled,
            scrollWheelZoom: !zoomDisabled,
            keyboard: !zoomDisabled,
            zoomControl: !zoomDisabled,
            whenReady: function whenReady() {
              var map = this;
              // Disable scroll until the map is clicked
              if (!zoomDisabled) {
                map.scrollWheelZoom.disable();
                map.on('focus', function () {
                  map.scrollWheelZoom.enable();
                });
                map.on('blur', function () {
                  map.scrollWheelZoom.disable();
                });
              }
            }
          },
          function () {
            var _require = require('react-leaflet'),
                FeatureGroup = _require.FeatureGroup,
                GeoJSON = _require.GeoJSON,
                Popup = _require.Popup,
                TileLayer = _require.TileLayer,
                Tooltip = _require.Tooltip;

            var MapMarker = require('./MapMarker').default;
            var MarkerClusterGroup = require('react-leaflet-markercluster').default;
            var displayMarkers = [];
            if (hasMarkers) {
              displayMarkers = filteredMarkers.map(function (marker) {
                var icon = defaultIcon;
                if (pins) {
                  var overridePin = pins.find(function (pinSettings) {
                    return pinSettings.when(marker);
                  });
                  if (overridePin) {
                    icon = new _leaflet.Icon(_extends({}, pin, overridePin));
                  }
                }
                var PopupWithContext = withContext(popup, _this4.context);

                return _react2.default.createElement(
                  MapMarker,
                  {
                    key: marker._id,
                    icon: marker.icon instanceof _leaflet.Icon ? marker.icon : icon,
                    position: [parseFloat(marker.geoIndexed[1]), parseFloat(marker.geoIndexed[0])],
                    isPopupOpen: marker._id === activePin
                  },
                  !!popup && _react2.default.createElement(
                    Popup,
                    { onOpen: _this4.onPopupOpen, onClose: _this4.onPopupClose },
                    _react2.default.createElement(PopupWithContext, { marker: marker })
                  )
                );
              });
            }
            return _react2.default.createElement(
              'div',
              null,
              !hideTiles && _react2.default.createElement(TileLayer, {
                maxZoom: 20,
                url: tileUrl + '?access_token=' + key,
                attribution: '\xA9 <a href=\'https://www.mapbox.com/about/maps/\'>Mapbox</a> \xA9 <a href=\'http://www.openstreetmap.org/copyright\'>OpenStreetMap</a> <strong><a href=\'https://www.mapbox.com/map-feedback/\' target=\'_blank\' rel=\'noopener noreferrer\'>Improve this map</a></strong>'
              }),
              hasMarkers && cluster && _react2.default.createElement(
                MarkerClusterGroup,
                null,
                displayMarkers
              ),
              hasMarkers && !cluster && displayMarkers,
              !!polygons && (polygons || []).length > 0 && _react2.default.createElement(
                FeatureGroup,
                { ref: function ref(group) {
                    _this4.polygonGroup = group;
                  } },
                polygons.map(function (polygon) {
                  var PolygonPopupWithContext = void 0;
                  if (polygon.popup) {
                    PolygonPopupWithContext = withContext(polygon.popup, _this4.context);
                  }

                  return _react2.default.createElement(
                    GeoJSON,
                    {
                      key: polygon.geometry.coordinates[0],
                      data: polygon,
                      style: function style() {
                        return polygon.style;
                      }
                    },
                    !!polygon.popup && _react2.default.createElement(
                      Popup,
                      { onOpen: _this4.onPopupOpen, onClose: _this4.onPopupClose },
                      _react2.default.createElement(PolygonPopupWithContext, {
                        marker: polygon
                      })
                    ),
                    !!polygon.tooltip && !popupOpen && _react2.default.createElement(
                      Tooltip,
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        polygon.tooltip
                      )
                    )
                  );
                })
              ),
              typeof children === 'function' ? children() : children
            );
          }
        )
      );
    }
  }]);

  return CoreMapComponent;
}(_react2.default.Component);

CoreMapComponent.propTypes = {
  /** Active pin popup, pass in an _id value */
  activePin: _propTypes2.default.string,
  /** Attempt to animate panning */
  animate: _propTypes2.default.bool,
  /** Percentage to increase the boundary size */
  boundaryPadding: _propTypes2.default.number,
  /** Minimum boundary size in meters */
  boundarySize: _propTypes2.default.number,
  /** Leaflet bounds, this is overriden when markers prop is passed */
  bounds: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.array), _propTypes2.default.instanceOf(_leaflet.LatLngBounds)]),
  /** Options for fitBounds */
  boundsOptions: _propTypes2.default.object,
  /** Center coordinates for the map, this is overridden when markers prop is passed */
  center: _propTypes2.default.arrayOf(_propTypes2.default.number),
  /** React nodes to render within map element */
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  className: _propTypes2.default.string,
  /** Cluster pins at lower zoom levels */
  cluster: _propTypes2.default.bool,
  hideTiles: _propTypes2.default.bool,
  /** Array of objects with geoIndexed property */
  key: _propTypes2.default.string,
  markers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    _id: _propTypes2.default.string,
    geoIndexed: _propTypes2.default.array
  })),
  /** Default Pin configuration */
  pin: _propTypes2.default.object,
  /** Conditional Pin configurations, object is merged with default pin */
  pins: _propTypes2.default.arrayOf(_propTypes2.default.object),
  /** Polygons to display on the map */
  polygons: _propTypes2.default.arrayOf(_propTypes2.default.object),
  /** Popup render function, passed marker as first param */
  popup: _propTypes2.default.func,
  tileUrl: _propTypes2.default.string,
  /** Use Fly to for changing bounds */
  useFlyTo: _propTypes2.default.bool,
  /** Set initial zoom 1-18 */
  zoom: _propTypes2.default.number,
  zoomDisabled: _propTypes2.default.bool
};

CoreMapComponent.defaultProps = {
  activePin: undefined,
  animate: undefined,
  boundaryPadding: undefined,
  boundarySize: undefined,
  bounds: undefined,
  boundsOptions: undefined,
  center: undefined,
  children: null,
  className: undefined,
  cluster: false,
  hideTiles: false,
  key: undefined,
  markers: undefined,
  pin: {
    iconUrl: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMTkgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjEgKDQ3MjUwKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5TaGFwZSBDb3B5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9ImRlc2t0b3AtaG9tZS1jYXJkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjM5LjAwMDAwMCwgLTIwOS4wMDAwMDApIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtMTUiIGZpbGw9IiM0QjRCNEIiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNDguMTgzODk4LDIyMi4xNzk3MTEgQzI0NS44OTMzMzMsMjIyLjE3OTcxMSAyNDQuMDM0NDgxLDIyMC4zMzkwMjMgMjQ0LjAzNDQ4MSwyMTguMDY4MjM4IEMyNDQuMDM0NDgxLDIxNS43OTUzMjMgMjQ1Ljg5MzMzMywyMTMuOTU1Njk5IDI0OC4xODM4OTgsMjEzLjk1NTY5OSBDMjUwLjQ3NDQ2MywyMTMuOTU1Njk5IDI1Mi4zMzMzMTUsMjE1Ljc5NjM4OCAyNTIuMzMzMzE1LDIxOC4wNjgyMzggQzI1Mi4zMzMzMTUsMjIwLjMzNzk1OCAyNTAuNDc0NDYzLDIyMi4xNzk3MTEgMjQ4LjE4Mzg5OCwyMjIuMTc5NzExIE0yNDguMTgzODk4LDIwOSBDMjQzLjExMTU0NywyMDkgMjM5LDIxMy4wNzQyMTMgMjM5LDIxOC4xMDEyNCBDMjM5LDIyMi44NDkzNDMgMjQzLjE1OTE1NSwyMjguOTczOTcgMjQ1LjkzNjYxMywyMzEuOTU1OTA2IEMyNDYuOTc0MjM4LDIzMy4wNjg0MSAyNDguMTgyODE2LDIzNC41Njg0MjcgMjQ4LjE4MjgxNiwyMzQuNTY4NDI3IEMyNDguMTgyODE2LDIzNC41Njg0MjcgMjQ5LjQ4MTE5OSwyMzMuMDU5ODkzIDI1MC41OTQ1NjMsMjMxLjkxNDM4NyBDMjUzLjM2OTg1NywyMjkuMDU3MDA4IDI1Ny4zNjY3MTQsMjIzLjMxOTg5NSAyNTcuMzY2NzE0LDIxOC4xMDEyNCBDMjU3LjM2NjcxNCwyMTMuMDc0MjEzIDI1My4yNTUxNjcsMjA5IDI0OC4xODM4OTgsMjA5IiBpZD0iU2hhcGUtQ29weSI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
    iconSize: [21, 30],
    iconAnchor: [11, 30],
    popupAnchor: [0, -35]
  },
  pins: undefined,
  polygons: undefined,
  popup: undefined,
  tileUrl: undefined,
  useFlyTo: undefined,
  zoom: undefined,
  zoomDisabled: false
};

CoreMapComponent.contextTypes = {
  router: _propTypes2.default.object.isRequired,
  store: _propTypes2.default.object.isRequired
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(CoreMapComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-coremap/build/CoreMap.js
// module id = 1199
// module chunks = 0